import React, { useEffect, useRef, useState } from 'react';
import './agency.scss';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useIntl } from 'react-intl';
import {
  getPaginationOpts,
  getResponseError,
  responseLogWithNotification,
  useFilterForm,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { getTelemetryData } from '../reducer';
import Loader from '../../../components/base/Loader/Loader';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../components/base/Pagination/Pagination';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TelemetryDTO from '../../../dto/TelemetryDTO';
import TelemetryForm from './TelemetryForm';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { showGlobalConfirm } from '../../System/actions';
import RangeDatePicker from '../../../components/fields/RangeDatePicker/RangeDatePicker';
import FilterForm from './FilterForm';
import { telemetryAdditionalColumns, telemetryColumns } from './telemetryColumns';
import {
  deleteTelemetry, loadTelemetryById, loadTelemetryByIdClear, loadTelemetryList,
} from '../actions';
import { TELEMETRY_MODULE, VIOLATIONS_MODULE } from '../../../configs/moduleNames';

export default function TelemetryPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [showView, setShowView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const { updatePeriod } = useSelector(getSystemData);

  const store = useStore();
  const {
    telemetryListMeta,
    loadingTelemetryList,
    telemetryList,
    loadingCurrentTelemetry,
    currentTelemetry,
    loadingCreateTelemetry,
    loadingEditTelemetryById,
    loadingDeleteTelemetry,
  } = useSelector(getTelemetryData);
  const { formatMessage } = useIntl();

  const loadTelemetry = id => {
    if (id) {
      dispatch(loadTelemetryById(id))
        .then(() => setShowForm(true))
        .catch(response => errorNotification('Загрузка телеметрии', getResponseError(response)));
    }
  };

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[TELEMETRY_MODULE].telemetryListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: getClearValues(),
    };
    const p1 = dispatch(loadTelemetryList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const {
    getValues, getClearValues, control, setValue, reset,
  } = useFilterForm({}, loadData, []);
  // } = useFilterForm({}, loadData, ['vehicle_id']);
  // const vid = getValues('vehicle_id');
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  // React.useEffect(() => loadTelemetry(getValues('vehicle_id')), [vid]);
  const DTO = new TelemetryDTO();
  const attributes = DTO.getAttributesByName();

  const handleSelectRow = item => {
    let select = item;
    if (selectedRow && selectedRow.vehicle_id === item.vehicle_id) {
      select = null;
    }
    setSelectedRow(select);
  };

  const handleCreate = () => {
    setIsEdit(false);
    setShowView(false);
    setShowForm(true);
    clearCurrentState();
  };

  const handleEdit = item => event => {
    if (!item) {
      return;
    }
    setValue('vehicle_id', item.vehicle_id);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDelete = item => event => {
    if (!item.vehicle_id) {
      errorNotification('Ошибка', 'Нет ID');
    }
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление телеметрии # ${item.vehicle_id}`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteTelemetry(item.vehicle_id)).then(() => {
        if (selectedRow === item.vehicle_id) {
          setSelectedRow(null);
        }
        loadData();
        successNotification('Удаление телеметрии', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление телеметрии', getResponseError(response));
      });
    }).catch(() => {});
    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const copyLink = item => event => {
    navigator.clipboard.writeText(`${window.location.href}?vehicle_id=${item.vehicle_id}`);
    successNotification('Копирование ссылки на нарушение', 'Ссылка на просмотр скопирована.');
  };

  const handleClose = () => {
    setShowForm(false);
    setValue('vehicle_id', '');
    clearCurrentState();
  };

  const clearCurrentState = () => {
    dispatch(loadTelemetryByIdClear()).catch(responseLogWithNotification);
  };

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={copyLink(item)}>
            Копировать ссылку
          </Button>
          {/* <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}> */}
          {/*  Просмотреть */}
          {/* </Button> */}
          {/* <Button variant="link" className="w-100 more-button delete" onClick={handleDelete(item)}> */}
          {/*  Удалить */}
          {/* </Button> */}
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    if (selectedRow && item.vehicle_id === selectedRow.vehicle_id) {
      classes.push('selected');
    }
    return classes.join(' ');
  };

  return (
    <div className="page application-page">
      <Loader loading={loadingTelemetryList || loadingCurrentTelemetry || loadingDeleteTelemetry || loadingCreateTelemetry || loadingEditTelemetryById} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.telemetry' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={RangeDatePicker}
            dtoObject={attributes.timestamp}
            hideSmallButtons
            showArrowIcon
            usePortal
            placeholder="Дата"
            changeFormat="YYYY-MM-DD"
            inputProps={{
              value: [getValues('timestamp_from'), getValues('timestamp_to')],
              onChange: e => {
                const v = e.target.value;
                setValue('timestamp_from', v[0]);
                setValue('timestamp_to', v[1]);
              },
            }}
            className="no-border"
          />
          {/* <div className="filter-sep" /> */}
          {/* <Button variant="second" onClick={() => setOpenFilter(true)}> */}
          {/*  <Icons customIcon width={24} height={24} icon="filter" /> */}
          {/* </Button> */}
          {/* <div className="filter-sep" /> */}
          {/* <Button variant="second" onClick={handleCreate}> */}
          {/*  <Icons */}
          {/*    customIcon */}
          {/*    width={24} */}
          {/*    height={24} */}
          {/*    icon="plus" */}
          {/*  /> */}
          {/* </Button> */}
          {isOpenFilter
            ? (
              <FilterForm
                control={control}
                onHide={() => {
                  setOpenFilter(false);
                }}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                setValue={setValue}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                onClickByRow={handleSelectRow}
                // onDoubleClickByRow={(item, event) => handleEdit(item)(event)}
                rowClassFormatter={rowClassFormatter}
                data={telemetryList}
                columns={telemetryColumns}
                additionalColumns={telemetryAdditionalColumns}
                name="telemetry-list"
                // settingsFormatter={moreFormatter}
              />
            </div>
          </div>
          <Pagination meta={telemetryListMeta} list={telemetryList} handleChangeMeta={loadData} />
        </div>
      </div>
      {showForm ? (
        <TelemetryForm
          currentTelemetry={currentTelemetry}
          isEdit={isEdit}
          loadData={loadData}
          onClose={handleClose}
          loadTelemetry={loadTelemetry}
        />
      ) : null}
    </div>
  );
}
